import { Box as View, BoxProps as ViewProps } from '@primer/react';
export default View;
export type { ViewProps };
